export function getPartnerLogoUrl(partner, defaultLogo) {
    
    if (!partner || partner === 'undefined' || !partner.logoPath || partner.logoPath === null || typeof partner.logoPath === 'undefined') {
        return defaultLogo;
    }

    if (partner.logoPath.startsWith('http')) {
        return partner.logoPath;
    }

    return process.env.VUE_APP_API +  partner.logoPath;
}